import { BlockContent, Icon, Image, Seo } from "@components";
import { LanguageContext } from "@contexts";
import { getDateString } from "@lib";
import { Body1, Heading1, Heading2 } from "@ui/typography";
import React, { useContext } from "react";

import { RelatedArticles } from "../RelatedArticles/RelatedArticles";
import * as styles from "./HappeningPage.module.scss";

export const HappeningPage = ({
  _type,
  currentArticleId,
  content,
  startTime,
  endTime,
  newsTag,
  children: event,
  publishDate,
}) => {
  const { title, introduction, mainImage, body } = content;
  const { localize } = useContext(LanguageContext);
  const date = getDateString(startTime, endTime);

  return (
    <>
      <Seo
        title={localize(title)}
        description={localize(introduction)}
        ogImage={mainImage.asset.gatsbyImageData.images.fallback.src}
      />
      <header className={styles.articleHeader}>
        <div>
          <Heading1 uppercase fontWeight="fontWeightLight"  fontSize="xxxlarge" >
            {localize(title)}
          </Heading1>
          {date && (
            <div className={styles.date}>
              <Icon symbol="calendar" strokeWidth={1} fill="none" />
              {date}
            </div>
          )}
          <Body1>{localize(introduction)}</Body1>
          {event}
        </div>
        <div className={styles.imageWrapper}>
          <Image
          aspectRatio={3 / 4}
          
            className={styles.image}

            asset={mainImage}
            alt={localize(title)}
          />
        </div>
      </header>
      <section className={styles.articleContent}>
        {body && (
          <BlockContent className={styles.body} blocks={localize(body)} />
        )}
        {publishDate && (
          <p className={styles.publishedDate}>
            Publisert:{" "}
            {new Date(publishDate).toLocaleDateString("no-nb", {
              day: "2-digit",
              month: "long",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </p>
        )}
      </section>
      <div className={styles.readMoreArticles}>
        <Heading2 uppercase fontWeight="fontWeightRegular">Les også:</Heading2>
        <RelatedArticles currentArticleId={currentArticleId} />
      </div>
    </>
  );
};
